<template>
  <div class="userProfileEdit">
    <el-dialog
      :title="`完善档案（${userInfo.name}-${userTypeName}）`"
      :visible.sync="visible"
      width="650px"
      :before-close="close"
      :close-on-click-modal="false"
      :close-on-press-escape="false">
      <div class="content">
        <div class="section">
          <el-form ref="form" :model="form" :rules="rules" label-width="140px">
            <el-form-item label="执业证书" prop="deptImg" class="imgwrap">
              <el-upload
                name="files"
                list-type="picture-card"
                :action="uploadUrl"
                :data="{ storagePath: 'picture' }"
                :file-list="form.licenseCertImages"
                accept="image/*"
                :with-credentials="true"
                :on-success="licenseCertImagesUpload"
                :on-remove="licenseCertImagesRemove">
                <i class="el-icon-plus avatar-uploader-icon"></i>
              </el-upload>
            </el-form-item>
            <el-form-item label="执业注册地" prop="practiceRegion">
              <el-cascader ref="regionCascader" v-model="form.practiceRegion" :props="{ label: 'areaName', value: 'areaCode' }" :options="areaList" placeholder="请选择省/市/区县" @change="areaChange"></el-cascader>
            </el-form-item>
            <el-form-item label="执业范围" prop="practiceScope">
              <el-select v-model="form.practiceScope" clearable multiple collapse-tags placeholder="请选择">
                <el-option v-for="(item, index) in practiceScopeList" :key="index" :label="item.label" :value="item.value"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="执业证书编码" prop="licenseCertCode">
              <el-input v-model="form.licenseCertCode" clearable placeholder="请输入"></el-input>
            </el-form-item>
            <el-form-item label="执业资格注册时间" prop="licenseRegDate">
              <el-date-picker
                v-model="form.licenseRegDate"
                type="date"
                :editable="false"
                value-format="yyyy-MM-dd"
                :picker-options="datePickerOptions"
                placeholder="选择日期">
              </el-date-picker>
            </el-form-item>
            <el-form-item label="资格证书编号" prop="qualificationCertCode">
              <el-input v-model="form.qualificationCertCode" clearable placeholder="请输入"></el-input>
            </el-form-item>
            <el-form-item label="获取资格书时间" prop="qualObtainDate">
              <el-date-picker
                v-model="form.qualObtainDate"
                type="date"
                :editable="false"
                value-format="yyyy-MM-dd"
                :picker-options="datePickerOptions"
                placeholder="选择日期">
              </el-date-picker>
            </el-form-item>

            <el-form-item label="职务" prop="positionTitle">
              <el-input v-model="form.positionTitle" clearable placeholder="请输入"></el-input>
            </el-form-item>
            <el-form-item label="本诊所开始执业时间" prop="currentClinicStartDate">
              <el-date-picker
                v-model="form.currentClinicStartDate"
                type="date"
                :editable="false"
                value-format="yyyy-MM-dd"
                placeholder="选择日期"
                @change="validateClinicDateRange">
              </el-date-picker>
            </el-form-item>
            <el-form-item label="本诊所结束执业时间" prop="currentClinicEndDate">
              <el-date-picker
                v-model="form.currentClinicEndDate"
                type="date"
                :editable="false"
                value-format="yyyy-MM-dd"
                placeholder="选择日期"
                @change="validateClinicDateRange">
              </el-date-picker>
            </el-form-item>
            <el-form-item label="执业开始时间" prop="practiceStartDate">
              <el-date-picker
                v-model="form.practiceStartDate"
                type="date"
                :editable="false"
                value-format="yyyy-MM-dd"
                placeholder="选择日期"
                @change="validatePracticeDateRange">
              </el-date-picker>
            </el-form-item>
            <el-form-item label="执业结束时间" prop="practiceEndDate">
              <el-date-picker
                v-model="form.practiceEndDate"
                type="date"
                :editable="false"
                value-format="yyyy-MM-dd"
                placeholder="选择日期"
                @change="validatePracticeDateRange">
              </el-date-picker>
            </el-form-item>
            <el-form-item label="是否具有处方权" prop="hasPrescriptionAuth">
              <el-radio-group v-model="form.hasPrescriptionAuth">
                <el-radio :label="true">是</el-radio>
                <el-radio :label="false">否</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="多点执业" prop="multiSitePractice">
              <el-radio-group v-model="form.multiSitePractice">
                <el-radio :label="true">是</el-radio>
                <el-radio :label="false">否</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="特殊处方权" prop="specialPrescriptionRights">
              <el-select v-model="form.specialPrescriptionRights" clearable multiple collapse-tags placeholder="请选择">
                <el-option v-for="(item, index) in specialPrescriptionList" :key="index" :label="item.label" :value="item.value"></el-option>
              </el-select>
            </el-form-item>
          </el-form>
        </div>
      </div>
      <div slot="footer" class="footer">
        <el-button @click="close">取 消</el-button>
        <el-button type="primary" @click="confirm">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import { provincesTree } from '@/api/region'
  import req from '@/utils/request'

  export default {
    name: 'userProfileEdit',
    data () {
      return {
        visible: false,
        uploadUrl: this.$filePath + '/xl/upload/temp/file/upload',
        areaList: [],
        practiceScopeList: [
          { label: '儿科专业', value: 1 },
          { label: '内科专业', value: 2 },
          { label: '中医专业', value: 3 },
          { label: '中医内科专业', value: 4 },
          { label: '中西医结合专业', value: 5 },
          { label: '全科医学专业', value: 6 }
        ],
        datePickerOptions: {
          disabledDate(time) {
            return time.getTime() > Date.now()
          }
        },
        specialPrescriptionList: [
          { label: '毒', value: 1 },
          { label: '麻', value: 2 },
          { label: '精', value: 3 },
          { label: '放', value: 4 },
          { label: '特', value: 5 }
        ],
        userInfo: {
          userId: '',
          name: '',
          type: ''
        },
        rules: {
          currentClinicStartDate: [
            { validator: (rule, value, callback) => this.validateClinicStartDate(rule, value, callback), trigger: 'change' }
          ],
          currentClinicEndDate: [
            { validator: (rule, value, callback) => this.validateClinicEndDate(rule, value, callback), trigger: 'change' }
          ],
          practiceStartDate: [
            { validator: (rule, value, callback) => this.validatePracticeStartDate(rule, value, callback), trigger: 'change' }
          ],
          practiceEndDate: [
            { validator: (rule, value, callback) => this.validatePracticeEndDate(rule, value, callback), trigger: 'change' }
          ]
        },
        form: {
          id: null,
          licenseCertImages: [],
          practiceRegion: [],
          practiceRegProvince: '',
          practiceRegCity: '',
          practiceRegDistrict: '',
          practiceScope: [],
          licenseCertCode: '',
          licenseRegDate: '',
          qualificationCertCode: '',
          qualObtainDate: '',
          positionTitle: '',
          currentClinicStartDate: '',
          currentClinicEndDate: '',
          practiceStartDate: '',
          practiceEndDate: '',
          hasPrescriptionAuth: '',
          multiSitePractice: '',
          specialPrescriptionRights: []
        }
      }
    },
    computed: {
      userTypeName () {
        const typeInfo = this.$userType.find(v => { return v.value == this.userInfo.type })
        return (typeInfo && typeInfo.label) || ''
      }
    },
    created () {
      this.getAreaTree()
    },
    methods: {
      getAreaTree() {
        if(!sessionStorage.getItem('nationalAreaList')) {
          provincesTree().then(res => {
            if (res.code === 200) {
              this.areaList = res.data
              sessionStorage.setItem('nationalAreaList', JSON.stringify(res.data))
            }
          })
        } else {
          this.areaList = JSON.parse(sessionStorage.getItem('nationalAreaList'))
        }
      },
      open (user) {
        this.visible = true
        this.userInfo.userId = user.userId || ''
        this.userInfo.name = user.name || ''
        this.userInfo.type = user.type ||''

        this.getDetail()
      },
      async getDetail () {
        const res = await req.get('/user/practice/getByUser', { userId: this.userInfo.userId })
        if (res.code === 200 && res.data) {
          this.form.id = res.data.id || null
          this.form.licenseCertImages = res.data.licenseCertImages.map(v => { return { name: v, url: v } })
          this.form.practiceRegion = [Number(res.data.practiceRegProvince), Number(res.data.practiceRegCity), Number(res.data.practiceRegDistrict)]
          this.form.practiceRegProvince = Number(res.data.practiceRegProvince)
          this.form.practiceRegCity = Number(res.data.practiceRegCity)
          this.form.practiceRegDistrict = Number(res.data.practiceRegDistrict)
          this.form.practiceScope = res.data.practiceScope || []
          this.form.licenseCertCode = res.data.licenseCertCode
          this.form.licenseRegDate = res.data.licenseRegDate
          this.form.qualificationCertCode = res.data.qualificationCertCode
          this.form.qualObtainDate = res.data.qualObtainDate
          this.form.positionTitle = res.data.positionTitle
          this.form.currentClinicStartDate = res.data.currentClinicStartDate
          this.form.currentClinicEndDate = res.data.currentClinicEndDate
          this.form.practiceStartDate = res.data.practiceStartDate
          this.form.practiceEndDate = res.data.practiceEndDate
          this.form.hasPrescriptionAuth = res.data.hasPrescriptionAuth
          this.form.multiSitePractice = res.data.multiSitePractice
          this.form.specialPrescriptionRights = res.data.specialPrescriptionRights || []
        }
      },
      async licenseCertImagesUpload(res) {
        if (res.errorCode == '0000') {
          const uploadRes = await req.post('/upload/fdfs/file/upload/fdfs', [{ uploadChannel: "licenseCertImage", fileId: res.data[0].fileId, groupName: "group1", isNeedThumbnail: "2" }], '/xl')
          if (uploadRes.errorCode == '0000') {
            const imageUrl = uploadRes.data && uploadRes.data[0] && uploadRes.data[0].fullPathUrl || ''
            this.form.licenseCertImages.push({ name: imageUrl, url: imageUrl })
          }
        }
      },
      licenseCertImagesRemove(res, fileList) {
        this.form.licenseCertImages = fileList
      },
      areaChange () {
        const area = this.$refs['regionCascader'].getCheckedNodes()[0]
        this.form.practiceRegProvince = area.path[0]
        this.form.practiceRegCity = area.path[1]
        this.form.practiceRegDistrict = area.path[2]
      },
      validateClinicStartDate (rule, value, callback) {
        const end = this.form.currentClinicEndDate
        if (value && end && value > end) {
          callback(new Error('开始时间不能晚于结束时间'))
        } else {
          callback()
        }
      },
      validateClinicEndDate (rule, value, callback) {
        const start = this.form.currentClinicStartDate
        if (value && start && start > value) {
          callback(new Error('结束时间不能早于开始时间'))
        } else {
          callback()
        }
      },
      validateClinicDateRange () {
        this.$refs.form && this.$refs.form.validateField(['currentClinicStartDate', 'currentClinicEndDate'])
      },
      validatePracticeStartDate (rule, value, callback) {
        const end = this.form.practiceEndDate
        if (value && end && value > end) {
          callback(new Error('开始时间不能晚于结束时间'))
        } else {
          callback()
        }
      },
      validatePracticeEndDate (rule, value, callback) {
        const start = this.form.practiceStartDate
        if (value && start && start > value) {
          callback(new Error('结束时间不能早于开始时间'))
        } else {
          callback()
        }
      },
      validatePracticeDateRange () {
        this.$refs.form && this.$refs.form.validateField(['practiceStartDate', 'practiceEndDate'])
      },
      close () {
        this.visible = false
        this.form = {
          id: null,
          licenseCertImages: [],
          practiceRegion: [],
          practiceRegProvince: '',
          practiceRegCity: '',
          practiceRegDistrict: '',
          practiceScope: [],
          licenseCertCode: '',
          licenseRegDate: '',
          qualificationCertCode: '',
          qualObtainDate: '',
          positionTitle: '',
          currentClinicStartDate: '',
          currentClinicEndDate: '',
          practiceStartDate: '',
          practiceEndDate: '',
          hasPrescriptionAuth: '',
          multiSitePractice: '',
          specialPrescriptionRights: []
        }
      },
      confirm () {
        this.$refs.form.validate(async (valid) => {
          if (valid) {
            let res = null
            if (this.form.id) {
              res = await req.put('/user/practice', {
                ...this.form,
                licenseCertImages: this.form.licenseCertImages.map(v => { return v.url })
              })
            } else {
              res = await req.post('/user/practice', {
                ...this.form,
                licenseCertImages: this.form.licenseCertImages.map(v => { return v.url }),
                userId: this.userInfo.userId
              })
            }
            if (res.code === 200) {
              this.$message.success('保存成功')
              this.close()
              this.$emit('confirm')
            }
          }
        })
      }
    }
  }
</script>

<style lang="less" scoped>
  .userProfileEdit /deep/ .el-dialog__header {
    padding: 12px 24px;
  }

  .userProfileEdit /deep/ .el-dialog__title {
    line-height: 24px;
    font-weight: 600;
    font-size: 16px;
    color: #000000;
  }

  .userProfileEdit /deep/ .el-dialog__headerbtn {
    top: 16px;
  }

  .userProfileEdit /deep/ .el-dialog__body {
    padding: 0px;
  }

  .userProfileEdit /deep/ .el-dialog__footer {
    padding: 0px;
  }

  .content {
    box-sizing: border-box;
    padding: 16px 24px;
    width: 100%;
    max-height: 500px;
    overflow-x: hidden;
    overflow-y: auto;
  }

  .section {
    width: 100%;
  }

  .footer {
    box-sizing: border-box;
    padding: 16px 24px;
    width: 100%;
    border-top: 1px solid #EBEAEE;
  }
</style>
